import { DomainEvent } from "../../components/utils/models/domainEvent";

export interface Card {

    id: 0,
    domainEvents: Array<DomainEvent>,
    created: Date,
    createdBy: string,
    lastModified: Date,
    lastModifiedBy: string,
    merchantId: 0,
    walletId: 0,
    cardNumber: string,
    visaReference: string,
    cardName: string,
    status: true,
    balance: 0,
    cardIssuer: string,
    stockCode: string,
    expiredDate: Date,
    lastBalanceUpdate: Date,

}

export interface DashboardInfo {
    companyName: string;
    accountId: string | null;
    accountBalance: number;
    cachBalance: number;
    type: string | null;
    typeId: number | null;
    wallets: Wallet[];
    merchantAccount: MerchantAccount;
}

export interface Wallet {
    name: string;
    minTreshold: number;
    status: number;
    numberOfCards: number;
    cashBalance: number;
    balanceOnCards: number;
    cards: Card[];
    id: 0,
    domainEvents: Array<DomainEvent>,
    created: Date
    createdBy: string,
    lastModified: Date
    lastModifiedBy: string,
    merchantId: 0,
    ledgerAccountId: 0,
    ledgerAccount?: ledgerAccount,
    fundingAccount: string
}

export interface Transaction {
    id: number;
    merchantId: number;
    walletId?: number | null;
    disbursementTransactionId?: number | null;
    fundingTransactionId?: number | null;
    counterparty: string;
    type: string;
    amount: number;
    description: string;
    status: string;
    merchantName: string;
    created: Date;
    statusDescription: string;
}

export interface ledgerAccount {
    id: 0,
    domainEvents?: Array<DomainEvent>,
    created: Date,
    createdBy: string,
    lastModified: Date,
    lastModifiedBy: string,
    type: 0,
    amount: 0,
    description: string,
}

export interface MerchantAccount {
    accountId: string;
    balance: number;
    minTreshold: number;
    fundingAccount: string;
}

export class FundingTransaction {
    merchantId: number;
    accountId?: number;
    transactionType: number;
    amount: number;
    description: string;

    constructor(
        merchantId: number,
        accountId: number | undefined,
        transactionType: number,
        amount: number,
        description: string
    ) {
        this.merchantId = merchantId;
        this.accountId = accountId;
        this.transactionType = transactionType;
        this.amount = amount;
        this.description = description;
    }
}

export interface Merchant {
    accountId: string;
    companyName: number;
    phoenixId: number;
    registrationNumber: string;
    type: string;
    merchantCategoryId: string;
    merchantCategory: string;
    accountStatus: number;
    fundingAccount: string;
    lastStatusChangeDateTime: Date;
}

export interface Option {
    text: string;
    value: number;
}


export class MerchantStatus {
    merchantId: number;
    actionType: ActionType;
    description: string;
    reasonType?: number;
    constructor(
        merchantId: number,
        actionType: ActionType,
        description: string,
        reasonType?: number
    ) {
        this.merchantId = merchantId;
        this.actionType = actionType;
        this.description = description;
        this.reasonType = reasonType;
    }
}


export class TopupMerchantAccount {
    merchantId: number;
    amount: number;
    fee: number;
    UserId: string;
    constructor(
        merchantId: number,
        amount: number,
        fee: number,
        UserId: string
    ) {
        this.merchantId = merchantId;
        this.amount = amount;
        this.fee = fee;
        this.UserId = UserId
    }
}

export class CardsCountQuery{
    status : string

    constructor(
        status : string)
    {
        this.status = status
    }
}

export class AllocateCardsToMerchant{
    MerchantId : number;
    WalletId : number;
    NumberOfCardsToAllocate : number;
    CardAllocationFee : number;
    KeycloakUserId : string;

    constructor(
        MerchantId : number,
        WalletId : number,
        NumberOfCardsToAllocate : number,
        CardAllocationFee : number,
        KeycloakUserId : string)
    {
        this.MerchantId = MerchantId
        this.WalletId = WalletId
        this.NumberOfCardsToAllocate = NumberOfCardsToAllocate
        this.CardAllocationFee = CardAllocationFee,
        this.KeycloakUserId = KeycloakUserId
    }
}

export class TopupMerchantWallet {
    merchantId: number;
    walletId: number;
    amount: number;
    UserId: string;

    constructor(
        merchantId: number,
        walletId: number,
        amount: number,
        UserId : string
    ) {
        this.merchantId = merchantId;
        this.walletId = walletId;
        this.amount = amount;
        this.UserId = UserId
    }
}

export enum ActionType {
    Approved,
    RequestAdditionalInformation,
    Declined
}